import { useEffect } from 'react';

const useImageLoadObserver = () => {
  useEffect(() => {
    const images = document.querySelectorAll('img[loading="lazy"]');
    
    images.forEach(img => {
      if (img.complete) {
        img.classList.add('loaded');
      } else {
        img.addEventListener('load', () => {
          img.classList.add('loaded');
        });
      }
    });

    // Observe new images
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            const newImages = node.querySelectorAll ? 
              node.querySelectorAll('img[loading="lazy"]') : [];
            newImages.forEach(img => {
              if (img.complete) {
                img.classList.add('loaded');
              } else {
                img.addEventListener('load', () => {
                  img.classList.add('loaded');
                });
              }
            });
          }
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, []);
};

export default useImageLoadObserver;
